import { BKJButton, BKJTextInput } from '@awais4123/fillify-design-library';
import { BKJFormWrapper } from 'components/BKJFormWrapper';
import { Flex } from 'components/Flex';
import { SetupBanner } from 'components/SetupBanner/SetupBanner';

import {
  CompanyProfileHeader,
  CompanyProfilePageWrapper,
  CompanyProfileContentWrapper,
  CompanyProfileButtonWrapper,
  CompanyProfileImageWrapper,
  LastChangedFooter,
} from 'pages/SettingsPage/CompanyProfilePage/CompanyProfilePage.styled';
import { Fragment, MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

import {
  CompanyProfilePageDataProvider,
  useCompanyProfilePageDataContext,
} from 'pages/SettingsPage/CompanyProfilePage/CompanyProfilePage.context';
import {
  CompanyProfilePageFormProvider,
  useCompanyProfilePageFormContext,
} from 'pages/SettingsPage/CompanyProfilePage/CompanyProfilePage.form.context';

import marketPlaceLogo from 'assets/marketPlaceLogo.svg';
import { LogoWrapper } from 'pages/SettingsPage/SettingsPage.styled';
import { DateTime } from 'luxon';
const CompanyProfileView = () => {
  const { data } = useCompanyProfilePageDataContext();
  const { values, onChange, onSubmit, fieldErrors } = useCompanyProfilePageFormContext();

  const { t } = useTranslation();

  const lastChanged = data?.me?.agency?.updatedAt || data?.me?.agency?.createdAt;

  const updatedBy =
    data?.me?.agency?.lastEditedBy?.firstName || data?.me?.agency?.lastEditedBy?.lastName
      ? `${data?.me?.agency?.lastEditedBy?.firstName} ${data?.me?.agency?.lastEditedBy?.lastName}`
      : '';

  return (
    <CompanyProfilePageWrapper flexDirection="column" width="100%" padding="32px 40px">
      <CompanyProfileContentWrapper>
        <Flex flexDirection="column" flexGrow={1}>
          <CompanyProfileHeader data-testid="hdr-userprofile">
            {t('settings:COMPANY_PROFILE')}
          </CompanyProfileHeader>
          <div>{t('settings:GENERAL_DETAILS')}</div>

          <Flex padding="18px 0 0 0" maxWidth="500px">
            <BKJTextInput
              name="company_name"
              label={t('settings:COMPANY_NAME')}
              onChange={onChange}
              value={values?.company_name}
              error={fieldErrors?.company_name}
            />
          </Flex>

          <Flex padding="18px 0 0 0" maxWidth="500px">
            <BKJTextInput
              name="licence_number"
              label={t('settings:LICENCE_NUMBER')}
              onChange={onChange}
              value={values?.licence_number}
              error={fieldErrors?.licence_number}
              maxLength={500}
            />
          </Flex>
          <CompanyProfileImageWrapper>
            {t('settings:ACCOUNT_TYPE')}
            <LogoWrapper alt="marketPlaceLogo" src={marketPlaceLogo} size="500px" />
          </CompanyProfileImageWrapper>
          <CompanyProfileButtonWrapper>
            <BKJButton
              variant="PurpleSolid"
              width="192px"
              disabled={false}
              onClick={onSubmit as unknown as MouseEventHandler<HTMLButtonElement>}
              type="submit"
            >
              {t('auth:SAVE')}
            </BKJButton>
          </CompanyProfileButtonWrapper>
          <Flex>
            {!!lastChanged && (
              <LastChangedFooter>
                {`${t('location_settings:LAST_CHANGED')}: ${DateTime.fromISO(lastChanged).toFormat(
                  `LLL d, yyyy 'at' h:mm a`,
                )} `}
                {!!updatedBy && <Fragment>{`${t('location_settings:BY')} ${updatedBy}`}</Fragment>}
              </LastChangedFooter>
            )}
          </Flex>
        </Flex>
      </CompanyProfileContentWrapper>
    </CompanyProfilePageWrapper>
  );
};

const CompanyProfileFormView = () => {
  const { data } = useCompanyProfilePageDataContext();
  if (!data) return null;
  return (
    <BKJFormWrapper>
      <CompanyProfilePageFormProvider>
        <SetupBanner />
        <CompanyProfileView />
      </CompanyProfilePageFormProvider>
    </BKJFormWrapper>
  );
};

export const CompanyProfilePage = () => {
  return (
    <CompanyProfilePageDataProvider>
      <CompanyProfileFormView />
    </CompanyProfilePageDataProvider>
  );
};
